var exports = {
  "q": "viewerContainer__nBAZwa",
  "v": "relationshipsContainer__YXSJZt",
};

module.exports = exports;
